import { isServer } from '@/mixins/helpers'

const cancelLoadingList = [
  'support/[\\d]+'
]

function isInCancelList (url) {
  let result = false
  for (const str of cancelLoadingList) {
    if (url.match(str)) {
      result = true
      break
    }
  }
  return result
}

export default function ({ $axios, redirect, store }) {
  $axios.onRequest((config) => {
    if (
      !isServer &&
      store.state.loadingEnable === true &&
      store.state.loadingManual === false &&
      !isInCancelList(config.url)
    ) {
      store._vm.$nuxt.$loading.start()
    }
    return config
  })

  $axios.onResponse((response) => {
    if (
      !isServer &&
      store.state.loadingManual === false
    ) {
      store._vm.$nuxt.$loading.finish()
    }
    if (isServer && ![200, 201, 204].includes(response.status)) {
      // eslint-disable-next-line no-console
      console.warn('ssr response', response.config.baseURL, response.config.url, response.status, response.data)
    }
    return response
  })

  $axios.onError((error) => {
    if (!isServer) {
      store._vm.$nuxt.$loading.finish()
    }
    if (isServer) {
      // eslint-disable-next-line no-console
      console.error('ssr error', error)
    }
    return Promise.reject(error)
  })
}
